var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersDuotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3853 11.0113C14.608 10.0998 15.3999 8.64239 15.3999 7C15.3999 5.66647 14.8779 4.45487 14.027 3.55842C14.6711 3.20255 15.4119 3 16.1999 3C18.6851 3 20.6999 5.01472 20.6999 7.5C20.6999 9.98528 18.6851 12 16.1999 12C15.1347 12 14.156 11.6299 13.3853 11.0113ZM17.5199 21.0004C18.0805 20.2259 18.3999 19.334 18.3999 18.3846C18.3999 16.4473 17.0699 14.7489 15.0738 13.8004H18.8999C21.3852 13.8004 23.3999 15.8151 23.3999 18.3004C23.3999 19.7915 22.1911 21.0004 20.6999 21.0004H17.5199Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3853 11.0113C14.608 10.0998 15.3999 8.64239 15.3999 7C15.3999 5.66647 14.8779 4.45487 14.027 3.55842C14.6711 3.20255 15.4119 3 16.1999 3C18.6851 3 20.6999 5.01472 20.6999 7.5C20.6999 9.98528 18.6851 12 16.1999 12C15.1347 12 14.156 11.6299 13.3853 11.0113Z",
    fill: "#9FD8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 19C1 16.2386 3.23858 14 6 14H12C14.7614 14 17 16.2386 17 19C17 20.6569 15.6569 22 14 22H4C2.34315 22 1 20.6569 1 19Z",
    fill: "#9FD8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7C4 4.23858 6.23858 2 9 2C11.7614 2 14 4.23858 14 7C14 9.76142 11.7614 12 9 12C6.23858 12 4 9.76142 4 7Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersDuotone);
export default __webpack_public_path__ + "static/media/usersDuotone.23a6e14f.svg";
export { ForwardRef as ReactComponent };